/**
 * Glasronde 0.9.235 (Frank 2 november 2026): Repo's toont standaard ALLE repo's waar je bij mag, met bovenaan een
 * filter: Alle, Persoonlijk, en elk team waar je lid van is. Het aantal volgt het filter, en het gekozen filter blijft
 * staan tot Frank het wijzigt.
 *
 * Aanleiding: TeamProef ontbrak in de lijst, omdat de lijst de actieve werkruimte volgde en nergens stond dat er
 * gefilterd werd. De beslissingen staan hier als pure functies (huisregel 4.8c).
 */
export const ALLE = "alle";
export const PERSOONLIJK = "persoonlijk";
const SLEUTEL = "novamund.repos.filter";

/** Een repo is een teamrepo als de backend er een teamnaam bij geeft (alleen bij een teamrol). PUUR. */
export function isTeamrepo(repo) {
  return Boolean(repo?.team_naam);
}

/** De repo's die bij deze keuze horen. Een onbekende keuze geeft alles, nooit niets. PUUR. */
export function filterRepos(repos, keuze) {
  const lijst = Array.isArray(repos) ? repos : [];
  if (keuze === PERSOONLIJK) return lijst.filter((r) => !isTeamrepo(r));
  if (keuze && keuze !== ALLE) return lijst.filter((r) => isTeamrepo(r) && r.team_id === keuze);
  return lijst;
}

/** De keuzes van het filter: Alle, Persoonlijk, dan elk team waar je lid van bent. PUUR. */
export function filterKeuzes(teams) {
  return [{ id: ALLE, naam: "Alle" }, { id: PERSOONLIJK, naam: "Persoonlijk" },
    ...(Array.isArray(teams) ? teams : []).map((tm) => ({ id: tm.id, naam: tm.name, team: true }))];
}

/** Een bewaarde keuze die niet (meer) bestaat, bijvoorbeeld een team waar je uit bent, wordt Alle. PUUR. */
export function geldigeKeuze(keuze, teams) {
  if (keuze === ALLE || keuze === PERSOONLIJK) return keuze;
  return (Array.isArray(teams) ? teams : []).some((tm) => tm.id === keuze) ? keuze : ALLE;
}

/** De bewaarde keuze op dit apparaat; zonder opslag (privévenster, geblokkeerd) gewoon Alle. */
export function leesKeuze() {
  try {
    return window.localStorage.getItem(SLEUTEL) || ALLE;
  } catch {
    return ALLE;
  }
}

export function bewaarKeuze(keuze) {
  try {
    window.localStorage.setItem(SLEUTEL, keuze);
  } catch {
    // Geen opslag: het filter geldt dan alleen tot het venster sluit.
  }
}
